import { useEffect, useState } from "react";
import { Bell, CheckCheck, ClipboardCheck, UserPlus, CheckCircle2 } from "lucide-react";
import { call, dateTime } from "@/lib/api";

const ICONS = { task: ClipboardCheck, assignment: UserPlus, approval: CheckCircle2 };

export function NotificationBell({ onNavigate }) {
  const [data, setData] = useState({ items: [], unread: 0, pending_approvals: 0 });
  const [open, setOpen] = useState(false);
  const load = () => call.get("/notifications").then(setData).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  const total = data.unread + (data.pending_approvals > 0 ? 1 : 0);
  const openItem = async (n) => { if (!n.read) { await call.post(`/notifications/${n.id}/read`, {}); load(); } setOpen(false); if (n.link) onNavigate(n.link); };
  return (
    <div className="notif-wrap">
      <button data-testid="notifications-button" className="icon-btn notification" onClick={() => setOpen(!open)}>
        <Bell size={18} />{total > 0 && <b className="notif-count" data-testid="notif-count">{total}</b>}
      </button>
      {open && <div className="notif-panel" data-testid="notif-panel">
        <div className="notif-head"><b>Notifikasi</b>{data.unread > 0 && <button className="ghost-btn pdf-btn" data-testid="notif-read-all" onClick={() => call.post("/notifications/read-all", {}).then(load)}><CheckCheck size={12} /> Tandai dibaca</button>}</div>
        {data.pending_approvals > 0 && <button className="notif-item unread" data-testid="notif-pending-approvals" onClick={() => { setOpen(false); onNavigate("approvals"); }}>
          <span className="alert-icon alert-1"><CheckCircle2 size={14} /></span><div><b>{data.pending_approvals} approval menunggu keputusan</b><small>PO / PR / Variation Order</small></div>
        </button>}
        {data.items.length === 0 && data.pending_approvals === 0 && <div className="division-empty">Belum ada notifikasi.</div>}
        {data.items.map(n => { const I = ICONS[n.type] || Bell; return (
          <button key={n.id} className={`notif-item ${n.read ? "" : "unread"}`} data-testid={`notif-${n.id}`} onClick={() => openItem(n)}>
            <span className={`alert-icon alert-${n.type === "task" ? 2 : 0}`}><I size={14} /></span><div><b>{n.title}</b><small>{n.body} · {dateTime(n.created_at)}</small></div>
          </button>); })}
      </div>}
    </div>
  );
}
